import { Helmet } from "react-helmet-async";

const BASE_URL = "https://psicologachiaramaiolo.it";

export default function SEO({ title, description, path = "/", keywords }) {
  const fullTitle = title
    ? `${title} · Dott.ssa Chiara Maiolo`
    : "Dott.ssa Chiara Maiolo · Psicologa a Chivasso (Torino)";
  const url = `${BASE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="it_IT" />
    </Helmet>
  );
}
